/**
 * Timeline constants - enum arrays and default configuration values.
 */

/** Valid precision values for event dating */
export const VALID_PRECISIONS = ['exact', 'year', 'decade', 'century', 'millennium', 'approximate'];

/** Valid dating basis values indicating how a date was determined */
export const VALID_DATING_BASIS = ['historical', 'narrative_sequence', 'inferred', 'traditional'];

/** Valid event categories */
export const VALID_CATEGORIES = ['biblical', 'church_history', 'world', 'personal'];

/** Valid depth levels: 0=era, 1=period, 2=event, 3=sub-event */
export const VALID_DEPTHS = [0, 1, 2, 3];

/** Valid relationship types for event links */
export const VALID_RELATIONSHIP_TYPES = ['related_to', 'caused_by', 'led_to', 'contemporary_with', 'part_of'];

/** Default colors for each event category */
export const CATEGORY_COLORS = {
  biblical: '#4A90D9',
  church_history: '#7B68EE',
  world: '#2ECC71',
  personal: '#F39C12'
};
